import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=efb77fb2&"
import script from "./Cards.vue?vue&type=script&lang=js&"
export * from "./Cards.vue?vue&type=script&lang=js&"
import style0 from "./Cards.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports